import React from 'react';

export const CheckedBoxSVG: React.FC<React.SVGProps<SVGSVGElement>> = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3 0.75H13C14.2426 0.75 15.25 1.75736 15.25 3V13C15.25 14.2426 14.2426 15.25 13 15.25H3C1.75736 15.25 0.75 14.2426 0.75 13V3C0.75 1.75736 1.75736 0.75 3 0.75Z"
        fill="#4B68EF"
        stroke="#4B68EF"
        strokeWidth="1.5"
      />
      <path
        d="M12.3836 4.95608C12.4836 5.05609 12.5398 5.19173 12.5398 5.33315C12.5398 5.47457 12.4836 5.6102 12.3836 5.71021L7.05029 11.0435C6.95027 11.1435 6.81464 11.1997 6.67322 11.1997C6.5318 11.1997 6.39617 11.1435 6.29615 11.0435L4.16282 8.91021C4.11188 8.86101 4.07125 8.80216 4.0433 8.7371C4.01535 8.67203 4.00064 8.60204 4.00002 8.53123C3.9994 8.46041 4.0129 8.39018 4.03972 8.32464C4.06653 8.25909 4.10613 8.19955 4.15621 8.14947C4.20629 8.09939 4.26583 8.05979 4.33138 8.03297C4.39692 8.00616 4.46715 7.99266 4.53797 7.99328C4.60878 7.99389 4.67877 8.00861 4.74384 8.03656C4.8089 8.06451 4.86776 8.10514 4.91695 8.15608L6.67322 9.91235L11.6295 4.95608C11.7295 4.8561 11.8651 4.79993 12.0066 4.79993C12.148 4.79993 12.2836 4.8561 12.3836 4.95608Z"
        fill="white"
      />
    </svg>
  );
};
